import { render, staticRenderFns } from "./ser_rel_export.vue?vue&type=template&id=0783073a&"
import script from "./ser_rel_export.vue?vue&type=script&lang=js&"
export * from "./ser_rel_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports